export enum ReviewAction {
	Cancel = 1,
	Save = 2,
	Approve = 3,
	Reject = 4,
	Review = 5,
}
